export default "__VITE_ASSET__Dhj5WWeb__"